import {
  PAYMENT_STATUS_CANCELLED,
  PAYMENT_STATUS_CAP_RECEIVED,
  PAYMENT_STATUS_DELIVERED,
  PAYMENT_STATUS_FAILED,
  PAYMENT_STATUS_GUARANTEED,
  PAYMENT_STATUS_INITIATED,
  PAYMENT_STATUS_PENDING,
  PAYMENT_STATUS_PROCESSING,
  PAYMENT_STATUS_RECEIVED,
  PAYMENT_STATUS_SENT,
  RECIPIENTS_WITH_GUARANTEED_TO_DELIVERED_STATUS,
} from 'constants/index';
import { getPayment, getRecipient, isCreditCardPayment } from 'selectors';

const paymentStatusMapper = {
  [PAYMENT_STATUS_CANCELLED]: PAYMENT_STATUS_CANCELLED,
  [PAYMENT_STATUS_DELIVERED]: PAYMENT_STATUS_DELIVERED,
  [PAYMENT_STATUS_INITIATED]: PAYMENT_STATUS_PENDING,
  [PAYMENT_STATUS_GUARANTEED]: PAYMENT_STATUS_RECEIVED,
  [PAYMENT_STATUS_PROCESSING]: PAYMENT_STATUS_SENT,
  [PAYMENT_STATUS_FAILED]: PAYMENT_STATUS_FAILED,
};

export const getUIPaymentStatus = (recipient, payment, state = {}) => {
  const { status, senderIndicatedSentAt } = payment;
  const APIStatus = paymentStatusMapper[status];
  const forCardSurcharge = isCreditCardPayment(state);

  if (isInitiated(status) && senderIndicatedSentAt) {
    return PAYMENT_STATUS_SENT;
  }
  if (
    (isRecipientWithGuaranteedToDeliveredStatus(recipient) ||
      forCardSurcharge) &&
    isGuaranteed(status)
  ) {
    return PAYMENT_STATUS_DELIVERED;
  }
  if (isCAP(recipient) && isReceived(status)) {
    return PAYMENT_STATUS_CAP_RECEIVED;
  }

  return APIStatus || status;
};
export const getUIStatusFromPolledStatus = (status, state = {}) => {
  const recipient = getRecipient(state);
  const payment = getPayment(state);
  payment.status = status;

  return getUIPaymentStatus(recipient, payment, state);
};

const isCAP = recipient => recipient.id === 'CAP';
const isGuaranteed = status => status === PAYMENT_STATUS_GUARANTEED;
const isInitiated = status => status === PAYMENT_STATUS_INITIATED;
const isReceived = status => status === PAYMENT_STATUS_RECEIVED;
const isRecipientWithGuaranteedToDeliveredStatus = recipient =>
  RECIPIENTS_WITH_GUARANTEED_TO_DELIVERED_STATUS.includes(recipient.id);
